module.exports = __webpack_public_path__ + "img/rfid_handheld_terminal.f90ccf46.png";